// import { useEffect, useState, useRef } from "react";
// // import { useState } from "react";
// import { supabase } from "./supabaseClient";
import "./style.css";
import "./hamburger.css";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

import CourseEnrollment from "./CourseEnrollment";
import Resources from "./Resources";
import EnrollmentsTable from "./EnrollmentsTable";
import { ThoughtBubble } from "./ThoughtBubble";
import CourseCard from "./CourseCard";
import CoursePage from "./CoursePage";
import { Footer } from "./Footer";
import Features from "./Features";
import PaymentPage from "./PaymentPage";

export default function App() {
	return (
		<Router>
			<Routes>
				<Route
					path="/"
					element={
						<>
							<Header />
							<Main />
							<Footer />
						</>
					}
				/>
				<Route path="/payment" element={<PaymentPage />} />

				<Route
					path="/content"
					element={
						<>
							<CoursePage />
						</>
					}
				/>
				<Route path="/courses/:courseId" element={<CoursePage />} />

				<Route
					path="/admin"
					element={
						<>
							<EnrollmentsTable />
						</>
					}
				/>
				<Route
					path="/enrollement"
					element={
						<>
							{/* <Header /> */}
							<div className="enrollment-page">
								<CourseEnrollment />
							</div>
							{/* <Footer /> */}
						</>
					}
				/>
				<Route
					path="/resources"
					element={
						<>
							<Resources />
						</>
					}
				/>
			</Routes>
		</Router>
	);
}

function Header() {
	return (
		<>
			<header className="header">
				<img
					src="header_curve.svg"
					alt="simplywebdev_header_curve"
					className="header__curve"
				></img>
				<nav className="nav">
					<img src="logo.svg" alt="simplywebdev_logo" className="nav__logo" />
					<div className="subnav">
						<ul className="nav__list">
							<li>
								<a href="#courses" className="btn nav__list__btn">
									Courses
								</a>
							</li>
							<li>
								<a href="#features" className="btn nav__list__btn">
									Features
								</a>
							</li>
							<li>
								<a href="#feedbacks" className="btn nav__list__btn">
									Feedbacks
								</a>
							</li>
						</ul>

						<button className="btn btn--blue nav__btn">
							<Link to="/enrollement">Enroll now</Link>
							<img src="up icon.svg" alt="simplywebdev up icon" />
						</button>
					</div>
				</nav>
			</header>

			{/* NEW: Hamburger Navigation - Only visible on mobile */}
			<div className="navigation">
				<input
					type="checkbox"
					className="navigation__checkbox"
					id="navi-toggle"
				/>

				<label htmlFor="navi-toggle" className="navigation__button">
					<span className="navigation__icon">&nbsp;</span>
				</label>

				<div className="navigation__background">&nbsp;</div>

				<nav className="navigation__nav">
					<ul className="navigation__list">
						<li className="navigation__item">
							<a
								href="#courses"
								className="navigation__link"
								onClick={() =>
									(document.getElementById("navi-toggle").checked = false)
								}
							>
								Courses
							</a>
						</li>
						<li className="navigation__item">
							<a
								href="#features"
								className="navigation__link"
								onClick={() =>
									(document.getElementById("navi-toggle").checked = false)
								}
							>
								Features
							</a>
						</li>
						<li className="navigation__item">
							<a
								href="#feedbacks"
								className="navigation__link"
								onClick={() =>
									(document.getElementById("navi-toggle").checked = false)
								}
							>
								Feedbacks
							</a>
						</li>
						<li className="navigation__item navigation__cta-item ">
							<Link
								to="/enrollement"
								className="navigation__cta-link"
								onClick={() =>
									(document.getElementById("navi-toggle").checked = false)
								}
							>
								Enroll now
								<img src="up icon.svg" alt="simplywebdev up icon" />
							</Link>
						</li>
						<li className="navigation__item">
							<img
								src="hero_arrow.svg"
								alt="arrow pointing to enroll"
								className="navigation__arrow"
							/>
						</li>
					</ul>
				</nav>
			</div>
		</>
	);
}

function Main() {
	return (
		<main className="main">
			<section className="section-hero">
				<div className="hero__content">
					<div>
						<label for="#" className="hero__label">
							Master Web Development, Simply.
						</label>
					</div>
					<div>
						<h1 className="hero__heading">
							NO COMPLEX THEORY.
							<br /> NO JARGON NEEDED.
							<br /> HANDS-ON SKILLS NOW.
						</h1>
						<p className="hero__sub-heading">
							Our courses are designed to take you from a complete beginner to a
							confident creator, one simple step at a time.
						</p>
						<button className="hero__btn btn--blue link__btn">
							<a href="#courses">Get started</a>
						</button>
					</div>
				</div>
				<div className="hero__img-box">
					<svg
						width="257"
						height="147"
						viewBox="0 0 257 147"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
						className="hero__thought"
					>
						<path
							d="M122.373 112.589L51.5991 146.597L64.2883 109.896L122.373 112.589Z"
							fill="#6699CC"
							fill-opacity="0.73"
						/>
						<path
							d="M16.802 118.744H220.558C227.632 118.744 234.421 114.102 235.721 108.383L256.785 14.4622C258.022 8.74279 253.327 4.10062 246.253 4.10062H42.4975C35.4233 4.10062 28.6346 8.74279 27.334 14.4622L6.30175 108.383C5.03284 114.102 9.72782 118.744 16.802 118.744Z"
							fill="#6699CC"
							fill-opacity="0.73"
						/>
						<g clip-path="url(#clip0_287_138)">
							<path
								d="M10.7227 114.644H214.478C221.553 114.644 228.341 110.002 229.642 104.282L250.706 10.3615C251.943 4.64218 247.248 0 240.174 0H36.4182C29.344 0 22.5553 4.64218 21.2546 10.3615L0.222404 104.282C-1.04651 110.002 3.64847 114.644 10.7227 114.644Z"
								fill="#D7DCED"
							/>
							<path
								d="M120.356 108.488L49.5828 142.497L62.2719 105.795L120.356 108.488Z"
								fill="#D7DCED"
							/>
						</g>
						<defs>
							<clipPath id="clip0_287_138">
								<rect width="250.896" height="142.497" fill="white" />
							</clipPath>
						</defs>

						<foreignObject x="30" y="10" width="190" height="100">
							<div
								xmlns="http://www.w3.org/1999/xhtml"
								className="hero__thought__container"
							>
								<ThoughtBubble />
							</div>
						</foreignObject>
					</svg>

					<img
						src="hero-ill-2.svg"
						alt="simply web dev hero img"
						className="hero__img"
					/>
				</div>
				<img
					src="hero_arrow.svg"
					alt="simplywebdev_hero_arrow"
					className="hero__arrow"
				/>
			</section>

			<Features />

			<section id="courses" className="section-courses">
				<button className="btn courses__btn">Our Courses</button>

				<h2 className="courses__heading">
					Designed a learning experience that's both effective and engaging
				</h2>
				<h3 className="courses__sub-heading">
					At SimplyWebDev, we believe anyone can become a skilled web developer.
				</h3>

				<div className="courses__list">
					<CourseCard
						imgSrc="htmlCss-img.svg"
						imgAlt="simplywebdev_htmlcss_img"
						category1="Web Development"
						category2="Beginner Friendly"
						title="HTML and CSS"
						description="Build your own stunning websites"
						tutorName="Soham Wani"
						tutorTitle="Web Developer"
						discountedPrice="3000"
						originalPrice="3500"
						link="/courses/html-css"
						tutorImg="/soham.jpeg"
					/>

					<CourseCard
						imgSrc="JavaScript-img.svg"
						imgAlt="simplywebdev_JavaScript_img"
						category1="Web Development"
						category2="Beginner Friendly"
						title="JavaScript"
						description="Build your own stunning websites"
						tutorName="Soham Wani"
						tutorTitle="Web Developer"
						discountedPrice="3000"
						originalPrice="3500"
						link="/courses/javascript"
						tutorImg="/soham.jpeg"
					/>

					<CourseCard
						imgSrc="UiUx-img.svg"
						imgAlt="simplywebdev_uiux_img"
						category1="UIUX"
						category2="Beginner Friendly"
						title="UI Designing"
						description="Build your own stunning website Designs"
						tutorName="Pradnya Kapuskar"
						tutorTitle="UIUX Designer"
						discountedPrice="3000"
						originalPrice="3500"
						link="/courses/ui-ux"
						tutorImg="/baad.jpeg"
					/>
				</div>
			</section>
		</main>
	);
}

<Footer />;
